import { Subject } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';

interface CustomInspectionChangeConfig {
  emitChange?: boolean;
  emitChangeTemplate?: boolean;
}
export class CustomInspectionContent {
  items: RestCustomInspectionContentItemModel[];
  private _itemsChanged = new Subject<RestCustomInspectionContentItemModel[]>();
  itemsChanges$ = this._itemsChanged.asObservable();

  private _templateChanges = new Subject<void>();
  templateChanges$ = this._templateChanges.asObservable();
  constructor(items: RestCustomInspectionContentItemModel[] = []) {
    this.init(items);
  }

  init(items: RestCustomInspectionContentItemModel[]) {
    this.items = [...items].sort((a, b) => {
      if (a.position > b.position) return 1;
      if (a.position < b.position) return -1;
      return 0;
    });
  }

  addItem(inspectionItemName: string) {
    const inspectionItemId = uuidv4();
    this.items.push({
      inspectionItemId,
      inspectionItemName,
      inspectionItemChecked: false,
    });
    this.onItemChanged();

    return inspectionItemId;
  }

  removeItem(id: string) {
    this.items = [...this.items.filter(item => item.inspectionItemId !== id)];
    this.onItemChanged();
  }

  updateItemName(item: RestCustomInspectionContentItemModel) {
    this.items = this.items.map(innerItem =>
      innerItem.inspectionItemId !== item.inspectionItemId
        ? innerItem
        : { ...innerItem, inspectionItemName: item.inspectionItemName }
    );
    this.onItemChanged();
  }
  updateItemChecked(item: RestCustomInspectionContentItemModel, config?: CustomInspectionChangeConfig) {
    this.items = this.items.map(innerItem =>
      innerItem.inspectionItemId !== item.inspectionItemId
        ? innerItem
        : { ...innerItem, inspectionItemChecked: item.inspectionItemChecked }
    );
    this.onItemChanged({ ...{ emitChangeTemplate: false }, ...config });
  }

  get templateItems() {
    return this.items.map(item => ({ ...item, inspectionItemChecked: false }));
  }

  onItemChanged(config: CustomInspectionChangeConfig = {}) {
    const options = { ...{ emitChange: true, emitChangeTemplate: true }, ...config };
    for (let i = 0; i < this.items.length; i++) {
      this.items[i].position = i;
    }
    if (options.emitChange) {
      this._itemsChanged.next(this.items);
    }

    if (options.emitChangeTemplate) {
      this._templateChanges.next();
    }
  }

  get totalItemsCount(): number {
    return this.items.length;
  }

  get checkedItemsCount(): number {
    return this.items.filter(item => item.inspectionItemChecked).length;
  }

  get progressBar(): number {
    return this.totalItemsCount ? (this.checkedItemsCount / this.totalItemsCount) * 100 : 100;
  }
}

export interface RestCustomInspectionModel {
  id?: number;
  inspectionName: string;
  isRequired?: boolean;
}
export interface RestCustomInspectionContentItemModel {
  inspectionItemName: string;
  inspectionItemChecked: boolean | null;
  inspectionItemId?: string;
  position?: number;
}
